<template>

    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Crear Cita</p>
                <argon-button color="success" size="sm" class="ms-auto"  @click="save"
                  >Guardar</argon-button
                >
              </div>
            </div>
            <div class="card-body">
            <!-- Tabs de navegación -->
            <ul class="nav nav-tabs" id="consultationTabs" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="patient-tab" data-bs-toggle="tab" data-bs-target="#patient" 
                  type="button" role="tab" aria-controls="patient" aria-selected="true">
                  Datos del Paciente
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="lensometry-tab" data-bs-toggle="tab" data-bs-target="#lensometry" 
                  type="button" role="tab" aria-controls="lensometry" aria-selected="false">
                  Lensometría
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="visual-acuity-tab" data-bs-toggle="tab" data-bs-target="#visual-acuity" 
                  type="button" role="tab" aria-controls="visual-acuity" aria-selected="false">
                  Agudeza Visual
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="examination-tab" data-bs-toggle="tab" data-bs-target="#examination" 
                  type="button" role="tab" aria-controls="examination" aria-selected="false">
                  Examen Clínico
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="refraction-tab" data-bs-toggle="tab" data-bs-target="#refraction" 
                  type="button" role="tab" aria-controls="refraction" aria-selected="false">
                  Refracción
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="diagnosis-tab" data-bs-toggle="tab" data-bs-target="#diagnosis" 
                  type="button" role="tab" aria-controls="diagnosis" aria-selected="false">
                  Diagnóstico y Conducta
                </button>
              </li>
            </ul>
            
            <!-- Contenido de los tabs -->
            <div class="tab-content" id="consultationTabsContent">
              <!-- Tab 1: Datos del Paciente -->
              <div class="tab-pane fade show active" id="patient" role="tabpanel" aria-labelledby="patient-tab">
                <div class="p-3">
                  <p class="text-uppercase text-sm">Información Personal</p>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label">Fecha de Consulta</label>
                      <argon-input type="date" v-model="consultation.date"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">Nombre Completo</label>
                      <argon-input type="text" v-model="consultation.full_name"/>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label">Documento</label>
                      <argon-input type="text" v-model="consultation.document"/>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label">Fecha de Nacimiento</label>
                      <argon-input type="date" v-model="consultation.birth_date"/>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label">Edad</label>
                      <argon-input type="number" v-model="consultation.age"/>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label">Teléfono</label>
                      <argon-input type="text" v-model="consultation.phone"/>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label">Ocupación</label>
                      <argon-input type="text" v-model="consultation.occupation"/>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label">EPS</label>
                      <argon-input type="text" v-model="consultation.eps"/>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label">Sexo</label>
                      <select class="form-select" v-model="consultation.sex">
                        <option value="M">Masculino</option>
                        <option value="F">Femenino</option>
                        <option value="O">Otro</option>
                      </select>
                    </div>
                    <div class="col-md-8">
                      <label class="form-control-label">Dirección</label>
                      <argon-input type="text" v-model="consultation.address"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">Correo Electrónico</label>
                      <argon-input type="email" v-model="consultation.email"/>
                    </div>
                  </div>
                  
                  <p class="text-uppercase text-sm mt-4">Información de Acompañante</p>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label">Nombre del Acompañante</label>
                      <argon-input type="text" v-model="consultation.companion_name"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">Teléfono del Acompañante</label>
                      <argon-input type="text" v-model="consultation.companion_phone"/>
                    </div>
                  </div>
                  
                  <p class="text-uppercase text-sm mt-4">Motivo de Consulta</p>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="form-control-label">Motivo de Consulta</label>
                      <textarea class="form-control" rows="3" v-model="consultation.consultation_reason"></textarea>
                    </div>
                    <div class="col-md-6 mt-3">
                      <label class="form-control-label">Fecha de Última Consulta</label>
                      <argon-input type="date" v-model="consultation.last_consultation_date"/>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Tab 2: Lensometría -->
              <div class="tab-pane fade" id="lensometry" role="tabpanel" aria-labelledby="lensometry-tab">
                <div class="p-3">
                  <p class="text-uppercase text-sm">Lensometría</p>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label">OD (Ojo Derecho)</label>
                      <argon-input type="text" v-model="consultation.lensometry_od"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">AVCC OD</label>
                      <argon-input type="text" v-model="consultation.lensometry_avcc_od"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">OI (Ojo Izquierdo)</label>
                      <argon-input type="text" v-model="consultation.lensometry_oi"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">AVCC OI</label>
                      <argon-input type="text" v-model="consultation.lensometry_avcc_oi"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">ADD</label>
                      <argon-input type="text" v-model="consultation.lensometry_add"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">Tipo de Lente</label>
                      <select class="form-select" v-model="consultation.lens_type">
                        <option value="Monofocal">Monofocal</option>
                        <option value="Bifocal">Bifocal</option>
                        <option value="Progresivo">Progresivo</option>
                        <option value="Ocupacional">Ocupacional</option>
                        <option value="Otro">Otro</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Tab 3: Agudeza Visual -->
              <div class="tab-pane fade" id="visual-acuity" role="tabpanel" aria-labelledby="visual-acuity-tab">
                <div class="p-3">
                  <p class="text-uppercase text-sm">Agudeza Visual de Lejos</p>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label">OD (Ojo Derecho)</label>
                      <argon-input type="text" v-model="consultation.visual_acuity_distance_od"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">OI (Ojo Izquierdo)</label>
                      <argon-input type="text" v-model="consultation.visual_acuity_distance_oi"/>
                    </div>
                  </div>
                  
                  <p class="text-uppercase text-sm mt-4">Agudeza Visual de Cerca</p>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label">OD (Ojo Derecho)</label>
                      <argon-input type="text" v-model="consultation.visual_acuity_near_od"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">OI (Ojo Izquierdo)</label>
                      <argon-input type="text" v-model="consultation.visual_acuity_near_oi"/>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Tab 4: Examen Clínico -->
              <div class="tab-pane fade" id="examination" role="tabpanel" aria-labelledby="examination-tab">
                <div class="p-3">
                  <p class="text-uppercase text-sm">Biomicroscopía</p>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label">OD (Ojo Derecho)</label>
                      <textarea class="form-control" rows="3" v-model="consultation.biomicroscopy_od"></textarea>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">OI (Ojo Izquierdo)</label>
                      <textarea class="form-control" rows="3" v-model="consultation.biomicroscopy_oi"></textarea>
                    </div>
                  </div>
                  
                  <p class="text-uppercase text-sm mt-4">Cover Test</p>
                  <div class="row">
                    <div class="col-md-4">
                      <label class="form-control-label">VL</label>
                      <argon-input type="text" v-model="consultation.cover_test_vl"/>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label">VP</label>
                      <argon-input type="text" v-model="consultation.cover_test_vp"/>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label">PPC</label>
                      <argon-input type="text" v-model="consultation.cover_test_ppc"/>
                    </div>
                  </div>
                  
                  <p class="text-uppercase text-sm mt-4">Oftalmoscopía</p>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label">OD (Ojo Derecho)</label>
                      <textarea class="form-control" rows="3" v-model="consultation.ophthalmoscopy_od"></textarea>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">OI (Ojo Izquierdo)</label>
                      <textarea class="form-control" rows="3" v-model="consultation.ophthalmoscopy_oi"></textarea>
                    </div>
                  </div>
                  
                  <p class="text-uppercase text-sm mt-4">PIO (Presión Intraocular)</p>
                  <div class="row">
                    <div class="col-md-4">
                      <label class="form-control-label">OD (Ojo Derecho)</label>
                      <argon-input type="text" v-model="consultation.pio_od"/>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label">OI (Ojo Izquierdo)</label>
                      <argon-input type="text" v-model="consultation.pio_oi"/>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label">Hora</label>
                      <argon-input type="time" v-model="consultation.pio_time"/>
                    </div>
                  </div>
                  
                  <p class="text-uppercase text-sm mt-4">Pruebas Adicionales</p>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label">Test de Estereopsis</label>
                      <argon-input type="text" v-model="consultation.stereopsis_test"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">Test de Color</label>
                      <argon-input type="text" v-model="consultation.color_test"/>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Tab 5: Refracción -->
              <div class="tab-pane fade" id="refraction" role="tabpanel" aria-labelledby="refraction-tab">
                <div class="p-3">
                  <p class="text-uppercase text-sm">Refracción</p>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label">OD (Ojo Derecho)</label>
                      <argon-input type="text" v-model="consultation.refraction_od"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">AV OD</label>
                      <argon-input type="text" v-model="consultation.refraction_av_od"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">OI (Ojo Izquierdo)</label>
                      <argon-input type="text" v-model="consultation.refraction_oi"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">AV OI</label>
                      <argon-input type="text" v-model="consultation.refraction_av_oi"/>
                    </div>
                  </div>
                  
                  <p class="text-uppercase text-sm mt-4">Subjetivo</p>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label">OD (Ojo Derecho)</label>
                      <argon-input type="text" v-model="consultation.subjective_od"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">AV OD</label>
                      <argon-input type="text" v-model="consultation.subjective_av_od"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">OI (Ojo Izquierdo)</label>
                      <argon-input type="text" v-model="consultation.subjective_oi"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">AV OI</label>
                      <argon-input type="text" v-model="consultation.subjective_av_oi"/>
                    </div>
                  </div>
                  
                  <p class="text-uppercase text-sm mt-4">Queratometría</p>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label">OD (Ojo Derecho)</label>
                      <argon-input type="text" v-model="consultation.keratometry_od"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">OI (Ojo Izquierdo)</label>
                      <argon-input type="text" v-model="consultation.keratometry_oi"/>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Tab 6: Diagnóstico y Conducta -->
              <div class="tab-pane fade" id="diagnosis" role="tabpanel" aria-labelledby="diagnosis-tab">
                <div class="p-3">
                  <p class="text-uppercase text-sm">Rx Final</p>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label">OD (Ojo Derecho)</label>
                      <argon-input type="text" v-model="consultation.final_rx_od"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">OI (Ojo Izquierdo)</label>
                      <argon-input type="text" v-model="consultation.final_rx_oi"/>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label">ADD</label>
                      <argon-input type="text" v-model="consultation.final_rx_add"/>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label">DP</label>
                      <argon-input type="text" v-model="consultation.final_rx_dp"/>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label">Tipo de Lente Final</label>
                      <select class="form-select" v-model="consultation.final_lens_type">
                        <option value="Monofocal">Monofocal</option>
                        <option value="Bifocal">Bifocal</option>
                        <option value="Progresivo">Progresivo</option>
                        <option value="Ocupacional">Ocupacional</option>
                        <option value="Otro">Otro</option>
                      </select>
                    </div>
                  </div>
                  
                  <p class="text-uppercase text-sm mt-4">Diagnóstico y Conducta</p>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="form-control-label">Diagnóstico</label>
                      <textarea class="form-control" rows="3" v-model="consultation.diagnosis"></textarea>
                    </div>
                    <div class="col-md-12 mt-3">
                      <label class="form-control-label">Conducta</label>
                      <textarea class="form-control" rows="3" v-model="consultation.conduct"></textarea>
                    </div>
                    <div class="col-md-12 mt-3">
                      <label class="form-control-label">Observaciones</label>
                      <textarea class="form-control" rows="3" v-model="consultation.observations"></textarea>
                    </div>
                  </div>
                  
                  <p class="text-uppercase text-sm mt-4">Información del Optometrista</p>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label">Nombre del Optometrista</label>
                      <argon-input type="text" v-model="consultation.optometrist"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">Número de Licencia</label>
                      <argon-input type="text" v-model="consultation.optometrist_license"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="d-flex justify-content-between mt-4">
              <argon-button color="secondary" size="sm" id="prevBtn" @click="navigateTabs('prev')" :disabled="activeTabIndex === 0">
                Anterior
              </argon-button>
              <argon-button color="primary" size="sm" id="nextBtn" @click="navigateTabs('next')" :disabled="activeTabIndex === 5">
                Siguiente
              </argon-button>
            </div>
          </div>

          </div>
        </div>
      </div>
    </div>

</template>

<style scoped>
.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Dos columnas iguales */
}
</style>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
const body = document.getElementsByTagName("body")[0];


export default {
  name: "User Create",
  data() {
    return {
      showMenu: false,
      activeTabIndex: 0,
      consultation: {
        id:0,
        // Datos del paciente
        date: new Date().toISOString().substr(0, 10),
        full_name: '',
        document: '',
        birth_date: '',
        age: '',
        phone: '',
        occupation: '',
        eps: '',
        sex: 'M',
        address: '',
        email: '',
        companion_name: '',
        companion_phone: '',
        consultation_reason: '',
        last_consultation_date: '',
        
        // Lensometría
        lensometry_od: '',
        lensometry_avcc_od: '',
        lensometry_oi: '',
        lensometry_avcc_oi: '',
        lensometry_add: '',
        lens_type: 'Monofocal',
        
        // Agudeza visual
        visual_acuity_distance_od: '',
        visual_acuity_distance_oi: '',
        visual_acuity_near_od: '',
        visual_acuity_near_oi: '',
        
        // Examen clínico
        biomicroscopy_od: '',
        biomicroscopy_oi: '',
        cover_test_vl: '',
        cover_test_vp: '',
        cover_test_ppc: '',
        ophthalmoscopy_od: '',
        ophthalmoscopy_oi: '',
        pio_od: '',
        pio_oi: '',
        pio_time: '',
        stereopsis_test: '',
        color_test: '',
        
        // Refracción
        refraction_od: '',
        refraction_av_od: '',
        refraction_oi: '',
        refraction_av_oi: '',
        subjective_od: '',
        subjective_av_od: '',
        subjective_oi: '',
        subjective_av_oi: '',
        keratometry_od: '',
        keratometry_oi: '',
        
        // Diagnóstico y conducta
        final_rx_od: '',
        final_rx_oi: '',
        final_rx_add: '',
        final_rx_dp: '',
        diagnosis: '',
        conduct: '',
        final_lens_type: 'Monofocal',
        observations: '',
        optometrist: '',
        optometrist_license: '',

        status:0,
      },
      user: {
        id:0,
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        role: '1',
        status: '1',
        phone: '',
        payment: '',
        processes: [],
      },
      processes: [],
    };
  },
  components: { ArgonInput, ArgonButton },
  methods: {
    navigateTabs(direction) {
      const tabs = document.querySelectorAll('#consultationTabs .nav-link');
      
      if (direction === 'next' && this.activeTabIndex < tabs.length - 1) {
        this.activeTabIndex++;
      } else if (direction === 'prev' && this.activeTabIndex > 0) {
        this.activeTabIndex--;
      }
      
      // Activar la pestaña correspondiente
      tabs[this.activeTabIndex].click();
    },
    
    calculateAge() {
      if (this.consultation.birth_date) {
        const birthDate = new Date(this.consultation.birth_date);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        
        this.consultation.age = age;
      }
    },
    async getOficios() {
      this.processes =  await this.$store.dispatch('users/getOficios'); 
    },
    async save() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("optometryRecords/save", this.consultation);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El usuario ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                    this.$router.push({ name: 'Appointment' });
              }
          });
        }else{
          throw new Error(response.data.message || 'Error al guardar el usuario');
        }
      } catch (error) {
        console.error("Error al crear el usuario:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el usuario',
        });
      }
    }
  },
  watch: {
    'consultation.birth_date': function() {
      this.calculateAge();
    }
  },
  mounted() {

    this.getOficios();

    const route = useRoute();
    const data = route.params.data;

   
    if (data) {
        try {
            const params = JSON.parse(data); // Asegúrate de que este JSON se pueda parsear

            // Verifica si params contiene los datos de user
            if (params && params.id) {
                // Llena los campos del formulario con los datos del usuario
                this.consultation = params;

            }
        } catch (error) {
            console.error("Error al parsear los datos del usuario:", error);
        }
    }

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>
